module.exports = __webpack_public_path__ + "img/cashback.ca5c4757.png";